import { coverStory, coverGuide, guideTag, sideNote } from "@/mocks/home";

export default function HeroCover() {
  return (
    <section id="cover" className="border-b border-background-200 bg-background-50 scroll-mt-32">
      <div className="px-4 md:px-6 py-8 md:py-12">
        <div className="flex items-center gap-3 mb-5">
          <span className="h-px flex-1 bg-background-200"></span>
          <span className="text-xs tracking-[0.2em] text-foreground-500 whitespace-nowrap">
            TODAY · 今日首发
          </span>
          <span className="h-px flex-1 bg-background-200"></span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <article className="lg:col-span-8 hlwp-fade-up">
            <div className="relative w-full h-[320px] md:h-[460px] overflow-hidden rounded-lg bg-background-200">
              <img
                src={coverStory.image}
                alt="黑料网曝今日首发封面，深夜删帖话题现场氛围"
                title="黑料网曝最新封面 深夜删帖"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/25 to-transparent"></div>
              <span className="absolute top-4 left-4 rounded-md bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                {coverStory.kicker}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h2 className="font-heading text-2xl md:text-4xl font-bold leading-snug text-background-50">
                  {coverStory.title}
                </h2>
              </div>
            </div>

            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              {coverStory.excerpt}
            </p>

            <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-user-line"></i>
                {coverStory.reporters}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                {coverStory.readTime}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line"></i>
                {coverStory.views} 阅读
              </span>
            </div>

            <div className="mt-4 flex flex-wrap gap-2">
              {coverStory.tags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900"
                >
                  # {tag}
                </span>
              ))}
            </div>
          </article>

          <aside className="lg:col-span-4 space-y-4">
            <div className="rounded-lg border border-background-200 bg-background-100/70 p-4 md:p-5">
              <div className="flex items-center justify-between gap-3 mb-4">
                <h3 className="font-heading text-lg font-bold whitespace-nowrap">封面导读</h3>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-900 whitespace-nowrap">
                  {guideTag.name} · {guideTag.value}
                </span>
              </div>
              <ol className="divide-y divide-background-200">
                {coverGuide.map((item) => (
                  <li key={item.no} className="group py-3 first:pt-0 last:pb-0">
                    <a href="#cover" className="flex items-start gap-3 cursor-pointer">
                      <span className="font-heading text-base font-bold text-primary-500/80 w-6 shrink-0 pt-0.5">
                        {item.no}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 hlwp-clamp-2">
                          {item.title}
                        </span>
                        <span className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                          <span className="flex items-center gap-1">
                            <i className="ri-time-line"></i>
                            {item.time}
                          </span>
                          <span className="rounded-full bg-background-200/70 px-2 py-0.5 text-foreground-700">
                            {item.tag}
                          </span>
                        </span>
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100/70 p-4 md:p-5">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold">
                <i className="ri-quill-pen-line text-primary-500"></i>
                {sideNote.title}
              </h3>
              <ul className="mt-3 space-y-2.5">
                {sideNote.lines.map((line) => (
                  <li key={line} className="flex gap-2 text-sm leading-relaxed text-foreground-600">
                    <span className="mt-2 w-1 h-1 rounded-full bg-accent-500 shrink-0"></span>
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}